module.exports = __webpack_public_path__ + "static/img/drop_solid_989EA3.b45d4e4e.svg";